import { getAHRISystemToolBrand } from "@crescentParts/Services/AHRISystemToolService";
import { AHRISystemToolModel } from "@crescentParts/Widgets/CustomApiModels";
import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

type Parameter = HasOnSuccess<AHRISystemToolModel>;

type Props = {
    apiResult: AHRISystemToolModel;
};

type HandlerType = Handler<Parameter, Props>;

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getAHRISystemToolBrand();
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [SendDataToApi, ExecuteOnSuccessCallback];

const getAHRISystemToolConfigurator = createHandlerChainRunner(chain, "getAHRISystemToolConfigurator");
export default getAHRISystemToolConfigurator;
